import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const stationRoutes: RouteObject[] = [
  {
    path: '/stations',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Stations',
      crumb: () => ({ label: 'Stations', to: '/stations' }),
    },
  },
  {
    path: '/station/view/:stationId',
    element: lazyElement(() => import('./View')),
    handle: { crumb: () => ({ label: 'Station' }) },
  },
];

export default stationRoutes;

